import request from '@/utils/request'

//增加运货单
export function AddAwbBI(data) {
    return request({
        url: '/TransportReport/AddAwbBI',
        method: 'post',
        data: data
    })
}

//修改运货单
export function UpdateAwbBI(data) {
    return request({
        url: '/TransportReport/UpdateAwbBI',
        method: 'post',
        data: data
    })
}

//查询报表
export function reportQuery(data) {
    return request({
        url: '/TransportReport/ReportQuery',
        method: 'post',
        data: data
    })
}

//查询季度汇总
export function QuarterQuery(data) {
    return request({
        url: '/TransportReport/QuarterQuery',
        method: 'post',
        data: data
    })
}
//查询月度汇总
export function MonthlyQuery(data) {
    return request({
        url: '/TransportReport/MonthlyQuery',
        method: 'post',
        data: data
    })
}

//折线图
export function MonthlyCompare(data) {
    return request({
        url: '/TransportReport/MonthlyCompare',
        method: 'post',
        data: data
    })
}

//3D图
export function NewMonthlyCompare(data) {
    return request({
        url: '/TransportReport/NewMonthlyCompare',
        method: 'post',
        data: data
    })
}